export default function dailyOpColor(stat) {
  switch (true) {
    case stat >= 50 && stat < 100:
      return 'text-yellow border-yellow'
    case stat >= 100:
      return 'text-green border-green'
    default:
      return 'text-fpx-red border-fpx-red'
  }
}